import * as Styled from './styled'
import { memo, MouseEvent, ReactElement, useCallback, useEffect, useState } from 'react'
import { Props } from './interfaces'
import Button from '~components/dumbs/Button'
import { useNavigate, useStore } from '~hooks'
import { track } from '@amplitude/analytics-browser'

const TimerButton = ({
  onClick,
  loading,
  seconds = 30,
  label = 'Enviar novamente',
  currentMethod,
}: Props): ReactElement => {
  const [timer, setTimer] = useState(seconds)
  const isTimerRunning = timer > 0

  const navigate = useNavigate()
  const store = useStore()

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    onClick?.(event)
    setTimer(seconds)
  }

  const decreaseTimer = useCallback(() => setTimer((seconds) => seconds - 1), [])

  useEffect(() => {
    let interval: NodeJS.Timer = null

    if (isTimerRunning) {
      interval = setInterval(() => {
        decreaseTimer()
      }, 1000)
    } else {
      clearInterval(interval)
    }
    return () => clearInterval(interval)
  }, [timer, isTimerRunning, decreaseTimer])

  const otherMethodLabel =
    currentMethod === 'sms' ? 'Recuperar por WhatsApp' : 'Recuperar por SMS'

  const changeHandleOtherMethodClick = (): void => {
    setTimer(seconds)

    track(
      currentMethod === 'sms'
        ? 'ignito__recuperacao_de_senha__seleciona_telefone__recupera_por_sms'
        : 'ignito__recuperacao_de_senha__seleciona_telefone__recupera_por_whatsapp',
      { phoneNumber: store.passwordRecovery.cellphone?.number },
    )
    navigate('/recuperar-senha-motorista/validar', {
      state: {
        previousPath: '/recuperar-senha-motorista',
        option: currentMethod === 'sms' ? 'whatsapp' : 'sms',
      },
    })
  }

  return isTimerRunning ? (
    <Styled.Timer>Aguarde... {timer} segundos</Styled.Timer>
  ) : (
    <Styled.ButtonsContainer>
      <Button type="button" color="tertiary" onClick={handleClick} loading={loading}>
        {label}
      </Button>
      <Button
        type="button"
        color="secondary"
        onClick={changeHandleOtherMethodClick}
        loading={loading}
      >
        {otherMethodLabel}
      </Button>
    </Styled.ButtonsContainer>
  )
}

export default memo(TimerButton)
